import React from 'react';

import TickIcon from 'icons/ic-tick.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import OutlinedButton from 'components/application/buttons/OutlinedButton';
import Toast from 'components/application/Toast';

export default function UndoableToast({
  isUndoActionDisabled = false,
  onBurnToast,
  onUndoAction,
  toastKey,
  toastText,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const undo = () => {
    onBurnToast(toastKey);
    onUndoAction();
  };

  return (
    <Toast
      burn={onBurnToast}
      burnTimer={8000}
      contents={
        <>
          <div className='toast__icon tw-bg-green-500'>
            <TickIcon
              className='[&_polygon]:tw-fill-white'
              height={20}
              width={20}
            />
          </div>
          <div className='toast__text'>{toastText}</div>
          <div className='tw-pl-8 tw-pt-3'>
            <OutlinedButton
              color='grey'
              disabled={isUndoActionDisabled}
              onClick={undo}
              size='sm'
            >
              {i18nTShared('undo')}
            </OutlinedButton>
          </div>
        </>
      }
      modifiers='with-undo'
      toastKey={toastKey}
    />
  );
}

UndoableToast.propTypes = {
  isUndoActionDisabled: PropTypes.bool,
  toastKey: PropTypes.string,
  toastText: PropTypes.object.isRequired,
  onBurnToast: PropTypes.func.isRequired,
  onUndoAction: PropTypes.func.isRequired,
};
